import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import DOMPurify from 'dompurify';
import { useTheme } from 'ThemeContext';
import Carrots from 'assets/Images/carrots.svg';
import {
  Content,
  Date,
  Decoration,
  Footer,
  Image,
  InnerTitle,
  Item,
  Meal,
  MealsBox,
  NextArrow,
  PrevArrow,
  Title,
  Wrapper
} from './WidgetSchoolMenu.style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons';

const WidgetSchoolMenu = ({ title = '', data = [] }) => {
  const theme = useTheme();
  const [options] = useState({
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    arrows: true,
    infinite: true,
    speed: 2,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: false
  });

  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <NextArrow onClick={onClick} theme={theme.widgetSchoolMenu.arrow}>
        <FontAwesomeIcon icon={faAngleRight} />
      </NextArrow>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <PrevArrow onClick={onClick} theme={theme.widgetSchoolMenu.arrow}>
        <FontAwesomeIcon icon={faAngleLeft} />
      </PrevArrow>
    );
  }

  return (
    <Wrapper theme={theme.widgetSchoolMenu}>
      {title && (
        <Title theme={theme.widgetSchoolMenu.title}>
          <Image src={Carrots} theme={theme.widgetSchoolMenu.image} alt='' />
          {title}
        </Title>
      )}
      <Slider {...options}>
        {data &&
          data.map((item, key) => (
            <Item key={key}>
              <Date theme={theme.widgetSchoolMenu.date}>{item.title}</Date>
              <MealsBox theme={theme.widgetSchoolMenu.mealsBox}>
                {item.children.map((meal, key2) => (
                  <Meal theme={theme.widgetSchoolMenu.meal} key={key2}>
                    <InnerTitle theme={theme.widgetSchoolMenu.innerTitle}>
                      {meal.title}
                    </InnerTitle>
                    <Content
                      theme={theme.widgetSchoolMenu.text}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(meal.content)
                      }}
                    />
                  </Meal>
                ))}
              </MealsBox>
              {item.content && (
                <Footer theme={theme.widgetSchoolMenu.footer}>
                  <Content
                    theme={theme.widgetSchoolMenu.footerText}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(item.content)
                    }}
                  />
                  <Decoration theme={theme.widgetSchoolMenu.decoration}>
                    !!!
                  </Decoration>
                </Footer>
              )}
            </Item>
          ))}
      </Slider>
    </Wrapper>
  );
};

export default WidgetSchoolMenu;
